import type { Homepage } from "@/payload-types";
import { NumbersSection, NumbersSectionItem } from "./numbers-section";

export function CmsNumbersSection(cmsProps: Homepage["ns"]) {
  if (!cmsProps || !cmsProps.items || cmsProps.items.length === 0) return null;

  return (
    <NumbersSection>
      {cmsProps.items.map(({ value, description, note }) => (
        <NumbersSectionItem key={value} value={value} description={description} note={note} />
      ))}
    </NumbersSection>
  );
}
